<template>
  <div name="challengelist" class="inner">


    <div class=" mt-4 p-4  ">

    <ul class="border-solid border-b border-grey-100 mb-4 pb-4">
                    <li>
                       <input type="search" class="h-full w-4/12 bg-white rounded shadow-sm p-2 mr-3"
                                         name="search"  v-model="search" placeholder="Enter challenge name..." >
                    </li>
                  </ul>

                <div v-if="errored" class="empty">
                    <p>We are not able to retrieve this information at the moment, please try back later</p>
                  </div>

                <div id="content-area" v-else>
                  <div style="width:100%; text-align:center;" v-if="loading" >
                    <i class="spinner fa fa-spinner fa-spin"></i>
                  </div>

                    <div v-else>
                    <div class="bg-white h-3/4 block overflow-y-auto rounded-md" v-if="componentLoaded" >
                       <table class="w-full mb-6 ">
                    <tr v-for="row in filteredList" :key="row.guid" class="bg-white even:bg-gray-200">
                      <td class="text-sm w-4/5">{{row.title}}</td>
                      <td @click="startChallenge(row)"
                          class="text-sm text-purple-600 text-right w-1/5 pr-10 cursor-pointer hover:opacity-75">
                           View
                      </td>
                    </tr>
                  </table>
                    </div>
                     <p class="m-5 mx-12" v-else>We could not find any data for your given selection.</p>
                  </div>
              </div>


        </div>

  </div>
</template>

<script>
import moment from 'moment'

import { mapGetters } from 'vuex'

import { ChallengeService } from "@/services/challenge.service";

const dropdown = () => import('@/components/Dropdown.vue')


export default {
  name: 'challengelist',
   props: {
    },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess"
    }),
    componentLoaded () {
      return this.filteredList.length > 0
    },
    orderedChallenges() {
       return _.orderBy(this.challenges, ["title"]);
    },
    filteredList() {
     return this.orderedChallenges.filter(item => {
       var vm = this;
       return item.title.toLowerCase().includes(vm.search.toLowerCase())
     })
   },
  },
  data () {
    return {
      loading: true,
      school: this.$store.getters.school,
      errored: false,
      challenges: [],
      search: '',
    }
  },
  created() {
    this.fetchChallenges()
  },
  mounted () {
    
  },
  methods: {
    fetchChallenges() {
      ChallengeService.getAll("challenges")
        .then(response => this.challenges = response.data.data)
        .catch(err => {
          console.log("challenges " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));

    },
    startChallenge(challenge) {
      this.$emit('challengeSelected', challenge)
    }
  },
  components: {
    dropdown
  }
}
</script>

<style>

.button-purple:disabled {
  @apply bg-gray-500 cursor-not-allowed
}
</style>